<template>
  <div class="extract-stats-dashboard">
    <a-spin :spinning="loading" tip="数据加载中..." size="large">
      <!-- 顶部标题栏 -->
      <header class="dashboard-header">
        <div class="header-content">
          <div class="header-left">
            <h1 class="page-title">专家抽取统计</h1>
            <p class="page-subtitle">Expert Extraction Statistics Dashboard</p>
          </div>
          <div class="header-right">
            <span class="date-label">抽取日期</span>
            <a-range-picker
                class="custom-date-picker"
                v-model="dateArr"
                :valueFormat="dateFormat"
                @change="onChangeDate"
                :placeholder="['开始日期', '结束日期']"
            />
          </div>
        </div>
      </header>

      <!-- 主要图表区 -->
      <section class="charts-section">
        <div class="chart-card">
          <div class="card-header">
            <h3 class="card-title">项目月度抽取统计</h3>
          </div>
          <div class="card-body">
            <multi-barchart id="projectMonthBarChart" ref="projectMonthBarChartChartRef"
                            style="width: 100%;height: 450px"/>
          </div>
        </div>
      </section>

      <!-- 底部图表区 -->
      <section class="bottom-section">
        <div class="bottom-card">
          <div class="card-header">
            <h3 class="card-title">专家参加/不参加统计</h3>
          </div>
          <div class="card-body">
            <e-char-pie-chart id="attendPieChart" ref="attendPieChartRef"
                              style="width: 100%;height: 380px"/>
          </div>
        </div>

        <div class="bottom-card">
          <div class="card-header">
            <h3 class="card-title">专家参加次数 TOP10</h3>
          </div>
          <div class="card-body">
            <multi-barchart id="topTenAttendBarChart" ref="topTenAttendBarChartRef"
                            style="width: 100%;height: 380px"/>
          </div>
        </div>
      </section>
    </a-spin>
  </div>
</template>

<script>

import ECharPieChart from '@/epp/statistics/Piechart.vue'
import MultiBarchart from '@/epp/statistics/MultiBarchart.vue'
import { GetExtractStatistic } from '@/epp/statistics/api/StatisticsRequest'
import { getCommonBarData, getCommonBarWithPieData, getCommonPieData } from '@/epp/statistics/util/StatisticsUtil'
import moment from 'moment'

export default {
  name: 'ExtractStatisticsIndex',
  components: {
    MultiBarchart,
    ECharPieChart,
  },
  data () {
    return {
      // 加载状态
      loading: false,
      dateArr: [moment(moment().get('year') + '-01-01', this.dateFormat), moment()],
      startDate: null,
      endDate: null,
      dateFormat: 'YYYY-MM-DD'
    }
  },
  created () {
    this.getExtractStatistic()
  },
  watch: {},
  methods: {
    //获取全部的统计数据
    async getExtractStatistic () {
      try {
        // 开始加载
        this.loading = true

        let res = await GetExtractStatistic({ startDate: this.startDate, endDate: this.endDate })
        if (200 !== res.code) {
          this.$message.error('获取抽取统计信息失败')
          return
        }
        this.initProjectMonthBarChartChartRef(res.result.extractProjectMonthStatistic)
        this.initAttendPieChart(res.result.extractAttendStatistic)
        this.initTopTenAttendBarChart(res.result.extractTopTenAttendStatistic)
      } catch (e) {
        this.$error({
          message: e.message || '获取抽取统计信息失败',
        })
      } finally {
        // 结束加载
        this.loading = false
      }
    },
    //初始化年龄柱状图
    initProjectMonthBarChartChartRef (extractProjectMonthStatistic) {
      let data = getCommonBarWithPieData(extractProjectMonthStatistic)
      let series = [{
        name: '项目数',
        type: 'bar',
        color: '#f10808',
        data: data.projectSeriesData,
        verticalAlign: 'top',
        label: {
          position: 'top',
          color: '#ffffff',  // 白色标签
          formatter: (val) => {
            return val.value === 0 ? '' : val.value + '个'
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return value + ' (个)'
          }
        },
      }, {
        name: '抽取人数',
        type: 'line',
        color: '#093fef',
        data: data.extractSeriesData,
        yAxisIndex: 1,
        label: {
          color: '#ffffff'  // 白色标签
        },
        tooltip: {
          valueFormatter: function (value) {
            return value + ' (人)'
          }
        }
      },
        {
          name: '参加人数',
          type: 'line',
          data: data.attendSeriesData,
          color: '#57f109',
          yAxisIndex: 1,
          label: {
            color: '#ffffff'  // 白色标签
          },
          tooltip: {
            valueFormatter: function (value) {
              return value + ' (人)'
            }
          }
        },
        {
          name: '不参加人数',
          type: 'line',
          data: data.busySeriesData,
          color: '#ec8106',
          yAxisIndex: 1,
          label: {
            color: '#ffffff'  // 白色标签
          },
          tooltip: {
            valueFormatter: function (value) {
              return value + '(人)'
            }
          },
        }]
      let xAxis = [{
        boundaryGap: true,
        data: data.xAxisData,
        axisLabel: {
          color: '#ffffff',  // 白色标签
          fontSize: 12
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.3)'  // 轴线颜色
          }
        }
      }]
      let yAxis = [{
        name: '项目数',
        type: 'value',
        min: 0,
        minInterval: 1,
        nameTextStyle: {
          color: '#ffffff',
          fontSize: 12,
          padding: [0, 0, 0, 0]
        },
        axisLabel: {
          formatter: '{value} 个',
          color: '#ffffff'
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.1)'  // 网格线颜色
          }
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.3)'  // 轴线颜色
          }
        }
      },
        {
          name: '人数',
          type: 'value',
          min: 0,
          nameTextStyle: {
            color: '#ffffff',
            fontSize: 12,
            padding: [0, 0, 0, 0]
          },
          axisLabel: {
            formatter: (val) => {
              return (val < 1 ? 1 : val) + '人'
            },
            color: '#ffffff'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'  // 网格线颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'  // 轴线颜色
            }
          }
        }]
      let legend= {
        orient: 'horizontal',
        left: 'center',
        top: '3%',  // 设置图例距离顶部3%
        itemGap: 25,  // 图例项之间的间距
        textStyle: {
          color: '#ffffff',  // 白色文字
          fontSize: 12
        },
        padding: [8, 0, 12, 0]  // 图例内边距
      }

      // 设置grid配置，为legend留出足够空间
      let grid = {
        top: '15%',  // 图表绘图区域从15%开始，给legend留出空间
        left: '3%',
        right: '4%',
        bottom: '5%',
        containLabel: true
      }

      this.$nextTick(() => {
        this.$refs.projectMonthBarChartChartRef.refreshData(series, xAxis, yAxis, '项目月度抽取统计', legend, grid)
      })
    },
    //初始化专家参加/不参加饼图
    initAttendPieChart (extractAttendStatistic) {
      let series = {
        radius: ['0', '70%'],
        data: getCommonPieData(extractAttendStatistic),
        // 饼图内部标签
        label: {
          position: 'inner',
          fontSize: 14,
        },
      }
      this.$nextTick(() => {
        this.$refs.attendPieChartRef.refreshData(series, '专家参加/不参加', '')
      })
    },
    //初始化专家参加次数前十柱状图
    initTopTenAttendBarChart (extractTopTenAttendStatistic) {
      let data = getCommonBarData(extractTopTenAttendStatistic)
      let series = [{
        name: '参加次数',
        color: '#54a22d',
        data: data.seriesData,
        tooltip: {
          valueFormatter: function (value) {
            return value + ' (次)'
          }
        },
        label: {
          show: true,
          formatter: '{c}次',
          textStyle: {
            color: '#000',
            fontSize: 14,
          }
        },
      }]
      let xAxis = [{
        boundaryGap: true,
        data: data.xAxisData,
      }]
      let yAxis = [{
        type: 'value',
        name: '参加次数',
        min: 0,
        minInterval: 1,
        nameTextStyle: {
          color: '#ffffff',
          fontSize: 12,
          padding: [0, 0, 0, 0]
        },
        axisLabel: {
          formatter: '{value} 次',
          color: '#ffffff'
        },
      }]

      this.$nextTick(() => {
        this.$refs.topTenAttendBarChartRef.refreshData(series, xAxis, yAxis, '专家参加前十')
      })
    },
    onChangeDate (date, dateString) {
      this.startDate = dateString[0]
      this.endDate = dateString[1]
      this.dateArr = date
      this.getExtractStatistic()
    },
  }
}
</script>

<style scoped lang="less">
.extract-stats-dashboard {
  min-height: calc(100vh - 120px);
  background: #1a1d2d;
  padding: 32px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

// ===== 顶部标题栏（左右布局，橙色系）=====
.dashboard-header {
  margin-bottom: 24px;
  padding: 20px 28px;
  background: #242838;
  border-radius: 8px;
  border-left: 4px solid #f59e0b;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.header-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.page-title {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #f1f5f9;
  letter-spacing: 0.3px;
}

.page-subtitle {
  margin: 0;
  font-size: 13px;
  color: #f59e0b;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;

  .date-label {
    font-size: 14px;
    color: #f59e0b;
    font-weight: 600;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }

  .custom-date-picker {
    ::v-deep .ant-calendar-picker-input {
      background: rgba(0, 0, 0, 0.2);
      border: 1px solid #334155;
      color: #f1f5f9;
      border-radius: 6px;
      font-size: 14px;
      border-left: 3px solid #f59e0b;
      min-width: 280px;
      text-align: center;

      &:hover {
        border-color: #f59e0b;
        box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
      }

      &:focus {
        border-color: #f59e0b;
        box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
      }

      &::placeholder {
        color: #64748b;
      }
    }

    ::v-deep .anticon {
      color: #f59e0b;
    }
  }
}

// ===== 图表卡片（顶部橙色装饰条）=====
.charts-section {
  margin-bottom: 20px;
}

.chart-card {
  background: #242838;
  border-radius: 8px;
  border: 1px solid #334155;
  overflow: hidden;
  transition: all 0.2s ease;
  position: relative;

  // 顶部橙色装饰条
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%);
    z-index: 1;
  }

  &:hover {
    border-color: #475569;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
    transform: translateY(-2px);
  }
}

.card-header {
  padding: 18px 24px;
  background: rgba(245, 158, 11, 0.05);
  border-bottom: 1px solid #334155;
  position: relative;
  z-index: 1;
}

.card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #f1f5f9;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #f59e0b;
    margin-right: 10px;
    border-radius: 2px;
  }
}

.card-body {
  padding: 24px;
  background: rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;

  ::v-deep .echarts-container {
    padding-bottom: 10px;
  }
}

// ===== 底部图表（同样的橙色风格）=====
.bottom-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.bottom-card {
  background: #242838;
  border-radius: 8px;
  border: 1px solid #334155;
  overflow: hidden;
  transition: all 0.2s ease;
  position: relative;

  // 顶部橙色装饰条
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%);
    z-index: 1;
  }

  &:hover {
    border-color: #475569;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
    transform: translateY(-2px);
  }

  .card-header,
  .card-body {
    position: relative;
    z-index: 1;
  }
}

// ===== 响应式设计 =====
@media (max-width: 992px) {
  .bottom-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .extract-stats-dashboard {
    padding: 16px;
  }

  .dashboard-header {
    padding: 20px;
    margin-bottom: 20px;

    .header-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    .header-right {
      width: 100%;

      .custom-date-picker {
        width: 100%;

        ::v-deep .ant-calendar-picker-input {
          min-width: 100%;
        }
      }
    }
  }

  .page-title {
    font-size: 22px;
  }
}

// ===== 滚动条样式（橙色系）=====
::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep ::-webkit-scrollbar-track {
  background: #0f1219;
  border-radius: 4px;
}

::v-deep ::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 4px;
  transition: background 0.2s ease;

  &:hover {
    background: #f59e0b;
  }
}

// ECharts z-index 提升
::v-deep .echarts-tooltip {
  z-index: 9999 !important;
}

::v-deep .echarts-legend {
  z-index: 100 !important;
}
</style>
